<div class="hint" [ngStyle]="{'display': displayCss}" #hint (mouseover)="showPopup($event)" (touchstart)="showPopup($event)">
  <svg-icon [src]="iconSrc" [ngClass]="['checkMark', 'checkMark_GRAY']" [svgStyle]="{ 'width.px':14, 'height.px':14 }" />
  <div class="hint__popup" #popup>
    <div class="triangle">
      <span class="triangle__top"></span>
      <span class="triangle__bottom"></span>
    </div>
    <ng-container *ngFor="let option of hintData; trackBy: trackByHint">
      <h5 class="popup__title">{{option.title}}</h5>
      <p class="popup__text" [innerHTML]="option.text"></p>
    </ng-container>
  </div>
</div>
